import { Market } from '@/creditflowresearch/domain/Market';
import { CorporateProduct, Product } from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import Segment from '@/creditflowresearch/domain/Segment';
import type { QuerySanitizer } from './types';

export const sanitize = (
  value: string | string[],
  getIds: (value: string | string[]) => string[],
  getAbbreviation: (id: string) => string | null,
): string | null => {
  const ids = getIds(value);
  if (!ids.length) return null;
  const validAbbreviations = ids.map(getAbbreviation).filter(Boolean);
  return validAbbreviations.length ? validAbbreviations.join(',') : null;
};

export const marketsValidator: QuerySanitizer = (value) =>
  sanitize(value, (v) => Market.getIds(v), (id) => Market.getAbbreviation(id));

export const productsValidator: QuerySanitizer = (value) =>
  sanitize(value, (v) => Product.getIds(v), (id) => Product.getAbbreviation(id));

export const regionsValidator: QuerySanitizer = (value) =>
  sanitize(value, (v) => Region.getIds(v), (id) => Region.getAbbreviation(id));

export const segmentsValidator: QuerySanitizer = (value) =>
  sanitize(value, (v) => Segment.getIds(v), (id) => Segment.getAbbreviation(id));

export const corporateProductsValidator: QuerySanitizer = (value) =>
  sanitize(value, (v) => Product.getIds(v), (id) =>
    CorporateProduct.CORPORATE_PRODUCT_IDS.includes(id) && Product.getAbbreviation(id),
  );
